<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="medium"
             color="#000000"
             type="ball-spin-clockwise">
</ngx-spinner>

<div class="modal-signup modal-content">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-0px">

        Add OQA

        <button type="button" class="close" data-dismiss="modal"
                (click)="activeModal.dismiss('Cross click')"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="card-body padding-bottom-0px padding-right-0px margin-left-0px">
        <form class="form" (ngSubmit)="onSubmit()" novalidate="" #f="ngForm">
          <div class="modal-body padding-top-0px">
            <div class="row margin-left-auto">
              <div class="col-md-12 padding-l-0px">

                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-3 text-align-right margin-top-5px">
                        <label for="diaplayName" class="margin-bottom-0px">Maturity</label>
                      </div>
                      <div class="col-md-4">
                        <!--<CodeTypeValue CodeType="OCTML"
                                       [(ngModel)]="CurrentSaveOocyteMaturityInfoRequest.MaturityLevel"
                                       required></CodeTypeValue>-->
                        <CodeTypeValue CodeType="OCTML" id="CurrentSaveOocyteMaturityInfoRequest.MaturityLevel"
                                       [(ngModel)]="CurrentSaveOocyteMaturityInfoRequest.MaturityLevel" SelectedValue=""
                                       name="CurrentSaveOocyteMaturityInfoRequest.MaturityLevel" required>

                        </CodeTypeValue>

                      </div>
                    </div>


                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-3 text-align-right margin-top-5px ">
                        <label for="diaplayName" class="margin-bottom-0px">OCC</label>
                      </div>
                      <div class="col-md-2 padding-right-0px">

                        <!--<input type="text" class="form-control" placeholder="" [(ngModel)]="CurrentSaveOocyteMaturityInfoRequest.OccCount"
         maxlength="2" required>-->
                        <CodeTypeValue CodeType="1to20" id="CurrentSaveOocyteMaturityInfoRequest.OccCount"
                                       [(ngModel)]="CurrentSaveOocyteMaturityInfoRequest.OccCount" SelectedValue=""
                                       name="CurrentSaveOocyteMaturityInfoRequest.OccCount" required>

                        </CodeTypeValue>
                     
                      </div>
                    </div>


                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-3 text-align-right margin-top-5px">
                        <label for="diaplayName" class="margin-bottom-0px">Denuded</label>
                      </div>
                      <div class="col-md-2 padding-right-0px">
                        <CodeTypeValue CodeType="1to20" id="CurrentSaveOocyteMaturityInfoRequest.DenudedCount"
                                       [(ngModel)]="CurrentSaveOocyteMaturityInfoRequest.DenudedCount" SelectedValue=""
                                       name="CurrentSaveOocyteMaturityInfoRequest.DenudedCount" required>

                        </CodeTypeValue>
                        <!--<input type="text" class="form-control" placeholder="" [(ngModel)]="CurrentSaveOocyteMaturityInfoRequest.DenudedCount"
         maxlength="2" required>-->
                        

                      </div>
                    </div>


                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>
            <button type="submit" class="btn actions-btn-prime float-right font-size-13px margin-right-auto">Save</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
